/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class WebsocketService {
    /**
     * Get websocket token
     * @param orgId Org Id
     * @param authorization The authorization token obtained from the login response. The value should be the IdToken.
     * @returns any
     * @throws ApiError
     */
    public static getSocketToken(
        orgId: string,
        authorization: string,
    ): CancelablePromise<{
        /**
         * The reason for the reboot
         */
        token: string;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/socket/token',
            headers: {
                'Authorization': authorization,
            },
            query: {
                'org_id': orgId,
            },
        });
    }
}
